import { InjectionToken, NgModule } from '@angular/core';
import { Router } from '@angular/router';

import { StoreConfig, StoreModule } from '@ngrx/store';

import { LanguageService } from '@fcom/ui-translate';
import { CartState } from '@fcom/dapi';
import { SentryLogger } from '@fcom/core';

import {
  bookingReducer,
  boundsReducer,
  cartReducer,
  multiCityReducer,
  offersReducer,
  paxDetailsReducer,
} from './reducers';
import { verifyCartInitialStateMetaReducer } from './metareducers';

export const CART_FEATURE_CONFIG_TOKEN = new InjectionToken<StoreConfig<CartState>>('Cart Feature Config');

export function getCartConfig(
  router: Router,
  languageService: LanguageService,
  sentryLogger: SentryLogger
): StoreConfig<CartState> {
  // return the config synchronously.
  return {
    metaReducers: [verifyCartInitialStateMetaReducer(router, languageService, sentryLogger)],
  };
}

@NgModule({
  imports: [
    StoreModule.forFeature('booking', bookingReducer),
    StoreModule.forFeature('cart', cartReducer, CART_FEATURE_CONFIG_TOKEN),
    StoreModule.forFeature('offers', offersReducer),
    StoreModule.forFeature('bounds', boundsReducer),
    StoreModule.forFeature('multiCity', multiCityReducer),
    StoreModule.forFeature('paxDetails', paxDetailsReducer),
  ],
  exports: [],
  declarations: [],
  providers: [
    {
      provide: CART_FEATURE_CONFIG_TOKEN,
      deps: [Router, LanguageService, SentryLogger],
      useFactory: getCartConfig,
    },
  ],
})
export class BookingStoreModule {}
